import { Injectable } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { Store } from '@ngrx/store';
import { HttpService } from './http.service';
import * as UserActions from '../_actions/user.action';
import { TokenUtil } from '../_utils/token.util';
import { IAppReducerState } from '../_reducers';
import { IErrorResponse, IUser, INursingHome } from '../_interfaces';
import { Broadcaster } from './broadcast.service';
import { ToastService } from '../_services/toast.service';

import {
  getAuth,
  signInWithEmailAndPassword
} from 'firebase/auth';
import { signOut } from 'firebase/auth';

interface ILoginRequestParams {
  email: string;
  password: string;
}

@Injectable()
export class AuthService {
  redirectPath = '';

  constructor(private http: HttpService,
              private bc: Broadcaster,
              private ts: ToastService,
              private store: Store<IAppReducerState>,
              private router: Router,
              ) {
  }
  login(params: ILoginRequestParams) {
    this.ts.info('ログイン中...');

    const auth = getAuth();
    signInWithEmailAndPassword(
      auth,
      params.email,
      params.password
    )
    .then(() => {

      if (auth.currentUser == null) {
        return;
      }

      this._fetchUserDetail((user) => {

        if (user.role !== 'root') {

          this.ts.error(
            'ログイン権限が不正なアカウントです。アカウントを見直してください'
          );

          TokenUtil.remove();

          signOut(auth);

          this.bc.broadcast('RouterUpdate', {
            role: null,
            callback: () =>
              this.router.navigate([this.redirectPath || '/login'])
          });

        } else {

          auth.currentUser!
            .getIdToken(false)
            .then((token) => {

              if (typeof token !== 'string') {
                return;
              }

              TokenUtil.set(token);
            });

          this.store.dispatch(new UserActions.Fetch(user));
          this.store.dispatch(new UserActions.Login());

          this.ts.success('ログインしました.');

          this.bc.broadcast('RouterUpdate', {
            role: user.role,
            callback: () =>
              this.router.navigate([this.redirectPath || '/'])
          });
        }
      });
    });
  }

  async logout() {
    this.redirectPath = location.pathname;
    this.store.dispatch(new UserActions.Logout());

    const auth = getAuth();

    await signOut(getAuth());

    if (getAuth().currentUser !== null) {
      console.warn('Logout failed: currentUser still exists');
      return;
    }

    TokenUtil.remove();

    this.bc.broadcast('RouterUpdate', {
      role: null,
      callback: () =>
        this.router.navigate(['/login'])
    });
  }

  private _fetchUserDetail(callback: (data?: any) => void): void {
    this.http.get<IUser>('/api/v2/pro/users/_self', null).subscribe((user) => {
      this.http.get<INursingHome>('/api/v2/pro/nursing-homes/:id', {id: user.nursingHomeId}).subscribe(nursingHome => {
        user.nursingHomeGroupId = nursingHome.nursingHomeGroupId;
        user.role = user.professionalRole;
        callback(user);
      });
    });
  }
}
